import { Component, Input, OnInit } from '@angular/core';
import TaskHelper from 'app/specialist/TaskHelper';
import { onsiteCopyOrderTaskTypes } from '../../../../../Scripts/app/models/collections/TaskTypeCollections';
import { TaskService } from '../../../../services/task.service';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import CustomerHelper from 'app/managecustomer/CustomerHelper';
import { CustomerKeyValuePairService } from '../../../../services/customer-keyvaluepair.service';

@Component({
  selector: 'app-components-managecustomer-task-details',
  templateUrl: './task-details.component.html'
})
export class TaskDetailsComponent implements OnInit {
  @Input() taskId: number;

  isLoading = false;
  isCustomOther = false;
  isOnsiteCopy = false;
  isOnsiteRecommendationImplementation = false;
  dfd: JQueryDeferred<void>;
  task: Boo.Objects.Task;
  taskTypeTips = '';
  selectedUrl: Boo.Objects.WebsiteUrl;
  customDescription = '';
  customName = '';
  customTaskTypeName = '';
  taskActionUrl = '';
  customBillableMinutes = 0;
  showTaskDescription: boolean;
  showRedoReason: boolean;
  onsiteCopyOrderReason = '';
  onsiteCopyLinkBuildAfterPublish: boolean;
  onsiteCopyPageType: string;
  onsiteCopyBoostToPublish: boolean;
  onsiteCopyImplementationInstructions: string;
  onsiteImplementationNoteToReviewer: string;
  taskTypeName: string;

  constructor(
    private taskService: TaskService,
    private customerKeyValuePairService: CustomerKeyValuePairService,
    private customerCampaignService: CustomerCampaignService) { }

  ngOnInit(): void {
    this.isLoading = true;

    this.taskService.getById(this.taskId)
      .subscribe((task) => {
        this.task = task;
        if (this.task.WebsiteUrlId) {
          this.customerCampaignService.getWebsiteUrl(this.task.WebsiteUrlId)
            .subscribe(url => {
              this.selectedUrl = url;
              this.initializeView();
              this.isLoading = false;
            });
        } else {
          this.initializeView();
          this.isLoading = false;
        }
      }, err => toastr.error(err));
  }

  cancel(): void {
    if (this.dfd) {
      this.dfd.resolve();
    }
  }

  private initializeView(): void {
    this.taskTypeName = this.task.TaskTypeSummary.Name;
    this.isCustomOther = this.task.TaskTypeEnum === Boo.Objects.Enums.TaskTypeEnum.Custom;
    this.isOnsiteCopy = onsiteCopyOrderTaskTypes.includes(this.task.TaskTypeEnum);
    this.isOnsiteRecommendationImplementation = this.task.TaskTypeEnum === Boo.Objects.Enums.TaskTypeEnum.OnsiteRecommendationImplementationManual;
    this.taskTypeTips = this.task.TaskTypeSummary.Tips || '';
    this.customDescription = TaskHelper.getCustomDescription(this.task);
    this.customName = TaskHelper.getCustomName(this.task);
    this.customTaskTypeName = TaskHelper.getCustomTaskTypeName(this.task);
    this.customBillableMinutes = TaskHelper.getCustomBillableMinutes(this.task);
    this.taskActionUrl = TaskHelper.getTaskActionUrl(this.task);
    this.onsiteImplementationNoteToReviewer = TaskHelper.getOnsiteImplementationNoteToReviewer(this.task);
    this.onsiteCopyOrderReason = TaskHelper.getOnsiteCopyOrderReason(this.task);
    this.onsiteCopyLinkBuildAfterPublish = TaskHelper.getOnsiteCopyLinkBuildAfterPublish(this.task);
    this.onsiteCopyPageType = TaskHelper.getOnsiteCopyPageType(this.task);
    this.onsiteCopyImplementationInstructions = TaskHelper.getOnsiteCopyImplementationInstructions(this.task);
    if (this.isOnsiteCopy) {
      this.customerKeyValuePairService.get(this.task.CustomerId)
        .subscribe((keyValuePairs: Boo.Objects.CustomerKeyValuePair[]) => {
          this.onsiteCopyBoostToPublish = CustomerHelper.getNumber(keyValuePairs, Boo.Objects.Enums.KeyEnum.ImplementationOwner) === Boo.Objects.Enums.ImplementationOwners.Boostability;
        });
    }
  }
}

